import { FC } from "react";
import { observer } from "mobx-react";
import { timeUnitLabel, toSubscriptionTypeDisplayKey } from "@/payment/Payment";
import { CURRENCY_NOK, formatPrice } from "@/utils/currency";
import { TMessage } from "@/i18n/tt";
import { useLanguage, useTranslation } from "@/stores/RootStoreContext";
import { SubscriptionStatusContext } from "@/common/subscription";
import { VBox } from "@/components-v2/Box";

export const SubscriptionName: FC<{
  context: SubscriptionStatusContext;
}> = observer(({ context }) => {
  const { t } = useTranslation();
  const locale = useLanguage();

  const subscriptionDisplayKey = toSubscriptionTypeDisplayKey(context.subscriptionType);
  const name = context.productDescription?.productLanguages.find(
    (p) => p.language === locale,
  )?.name;

  const formattedDescription: TMessage = context.tier
    ? {
        key: "subscription.withtiertype.shareholder_interval",
        params: { company: context.companyName, name: name, n: context.tier?.tier },
      }
    : {
        key: "payment.subscriptionpopup.currentSubscription.description",
        params: { company: context.companyName, name: name },
      };
  return context.subscriptionType || context.productDescription ? (
    <VBox>
      <p>
        {formattedDescription
          ? t(formattedDescription) +
            (context.productDescription?.productName
              ? ` (${context.productDescription.productName})`
              : " ")
          : subscriptionDisplayKey
            ? t("subscription.legacy.subscriptionname", {
                company: context.companyName,
                name: t(subscriptionDisplayKey),
              })
            : ""}
      </p>
      {context.currentPrice && context.billInterval && (
        <>
          {formatPrice(locale, CURRENCY_NOK, context.currentPrice)}
          {t(timeUnitLabel[context.billInterval])}
        </>
      )}
    </VBox>
  ) : (
    <div>{t("payment.subscriptionpopup.description", { name: context.companyName })}</div>
  );
});
